import React from 'react';
import {LoadableReactLeafletMap, MapControls} from '@gisatcz/ptr-maps';
import RiskAssessmentMap from './RiskAssessmentMap';
import InterferometryMap from './InterferometryMap';
import LayersWrapper from './LayersWrapper';

import './style.scss';

class MainMap extends React.PureComponent {
	render() {
		if (this.props.activeMapKey === 'risk-assessment-big') {
			return this.renderMap(RiskAssessmentMap);
		} else if (this.props.activeMapKey === 'interferometry-big') {
			return (
				<div className="eo4sdDrrInsarVietnam20-main-map">
					<InterferometryMap
						mapComponent={LoadableReactLeafletMap}
						stateMapKey={this.props.activeMapKey}
						wrapper={LayersWrapper}
					>
						<MapControls zoomOnly levelsBased />
					</InterferometryMap>
				</div>
			);
		} else {
			return null;
		}
	}

	renderMap(mapComponent) {
		return (
			<div className="eo4sdDrrInsarVietnam20-main-map">
				{React.createElement(
					mapComponent,
					{
						mapComponent: LoadableReactLeafletMap,
						stateMapKey: this.props.activeMapKey,
						wrapper: LayersWrapper,
					},
					<MapControls zoomOnly levelsBased />
				)}
			</div>
		);
	}
}

export default MainMap;
